import { z } from 'zod';

import { type Common } from './common.js';

export const UtilizationDashboardVariantSchema = z.enum(['SplitContract', 'Platform']);

export type UtilizationDashboardVariant = z.infer<typeof UtilizationDashboardVariantSchema>;

export const UtilizationDashboardOrganizationSchema = z.object({
  organizationId: z.string(),
  organizationName: z.string(),
  contentPath: z.string(),
  variant: UtilizationDashboardVariantSchema,
});

export type UtilizationDashboardOrganization = z.infer<
  typeof UtilizationDashboardOrganizationSchema
>;

export const UtilizationDashboardAvailabilitySchema = z.discriminatedUnion('availability', [
  z.object({ availability: z.literal('Unavailable') }),
  z.object({
    availability: z.literal('Available'),
    organizations: z.array(UtilizationDashboardOrganizationSchema).min(1),
  }),
]);

export type UtilizationDashboardAvailability = z.infer<
  typeof UtilizationDashboardAvailabilitySchema
>;

export interface GetUtilizationDashboardOmniUrlArgs {
  organizationId?: string;
  timeZone?: string;
}

export interface GetUtilizationDashboardOmniUrlResponse {
  src: string;
  organizationId: string;
  contentPath: string;
}

export class API {
  common: Common;
  baseEndpoint = '/utilization-dashboard';

  constructor(common: Common) {
    this.common = common;
  }

  async getAvailability(): Promise<UtilizationDashboardAvailability> {
    const url = this.common.constructPath(`${this.baseEndpoint}/availability`);
    return await this.common.getJSON(url);
  }

  async getOmniUrl(
    args: GetUtilizationDashboardOmniUrlArgs = {}
  ): Promise<GetUtilizationDashboardOmniUrlResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/embed`);
    return await this.common.postJSON(url, args);
  }
}
